import { useMemo, useState } from 'react';
import { List } from 'immutable';
import { useSelector } from 'react-redux';

import useLabelHandlers from './useLabelHandlers';
import useLabelRefresh from './useLabelRefresh';

import { selectSelectedElementsNormalisedForTaskLists } from '../../../../selector/selectionToolsSelector';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { getFullLabelFetchTimestamp, selectUsableLabels } from '../../../../../../element/labels/labelSelectors';
import { getUniqueUsedLabelIds } from '../../../../../../../common/elements/utils/elementLabelUtils';
import type { LabelsToolController } from './labelsToolTypes';

type Props = {
    currentUserId: string;
    isActive?: boolean;
};

const useLabelsTool = ({ currentUserId, isActive = true }: Props): LabelsToolController => {
    useLabelRefresh({ isActive });

    const labelMap = useSelector(selectUsableLabels);
    const fullLabelFetchTimestamp = useSelector(getFullLabelFetchTimestamp);
    const allLabels = Object.values(labelMap || {});
    const elements: List<ImMNElement> = useSelector(selectSelectedElementsNormalisedForTaskLists);
    const selectedLabelIds = useMemo(() => new Set(getUniqueUsedLabelIds(elements)), [elements]);
    const [searchString, setSearchString] = useState('');
    const hasCompletedInitialFetch = fullLabelFetchTimestamp !== null;

    const { handleToggleLabelSelection, handleCreateLabel, handleSearchSubmit } = useLabelHandlers(
        currentUserId,
        searchString,
        setSearchString,
        elements,
        allLabels,
    );

    return {
        allLabels,
        selectedLabelIds,
        hasCompletedInitialFetch,
        searchString,
        setSearchString,
        handleCreateLabel,
        handleSearchSubmit,
        handleToggleLabelSelection,
    };
};

export default useLabelsTool;
